import {Deserializable} from "./deserializable.model";

export class SubjectWorkOrderItem {


work_order_item_id?: number;
work_order_id?: number;
work_order_number?: string;
cost_task_id?: number;
subject_cost_item_id?: number;
cost_task_name?: string;
myob_tax_code_id?: number;
myob_account_code_id?: number;
cost_task_fee?: number;
cost_task_description?: string;
subject_id?: number;
subject_number?: string;
job_id?: number;
job_number?: string;
qty?: number;
unit_price?: number;
tax?: number;
total?: number;
agent_id?: number;
agent_full_name?: string;


myob_id?
myob_array?;
// MYOB Variable inclsions
RowID?;
Type?;
Description?;
UnitOfMeasure?;
UnitCount?;
UnitPrice?;
UnitPriceForeign?;
DiscountPercent?;
Total?;
TotalForeign?;
AccountUID?;
JobUID?;
TaxCodeUID?;
TaxCodeCode?;
RowVersion?;

is_bulk?;





  // ? what does this really do? (no encoding or deserialisation required...)
  // deserialize(input: any): SubjectInvoiceItem {
  //   Object.assign(this, input);

  //   return this;
  // }

  /*
work_order_item_id
work_order_id
billing_task_id
subject_billing_item_id
billing_task_name
myob_tax_code_id
myob_account_code_id
billing_task_fee
billing_task_description
subject_id
subject_number
job_id
job_number
qty
unit_price
tax
total
work_order_number
  */


}
